import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";
import { COMPANY } from "../data/content";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#050a11]/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-6 md:px-10 h-20 flex items-center justify-between text-white">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="font-display font-extrabold text-xl tracking-tight">TOP&nbsp;C</span>
          <span className="font-mono-x text-[10px] leading-none text-white/50 border border-white/20 rounded px-1.5 py-1">
            GROUP
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `overline link-sweep transition-opacity ${isActive ? "opacity-100" : "opacity-60 hover:opacity-100"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta"
            className="group inline-flex items-center gap-2 bg-white text-[#0b2046] font-medium text-sm rounded-full pl-5 pr-4 py-2.5 hover:bg-[#9dc0ff] active:scale-[0.98] transition-[background-color,transform]"
          >
            Start a partnership
            <ArrowUpRight size={16} weight="bold" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#050a11] border-t border-white/10 px-6 py-8 flex flex-col gap-6 text-white">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="font-display text-3xl tracking-tight"
            >
              {l.label}
            </NavLink>
          ))}
          <div className="pt-4 border-t border-white/10 font-mono-x text-xs text-white/50">{COMPANY.ssm}</div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
